import React from "react";
import { Button, Input } from 'antd';
import Banner from './banner'; // 社交按钮
import { RegName , RegEmail , RegPassword , RegPhone} from '$CONFIG/common/reg';
import { ApiPort } from "../../actions/API";
import { fetchRequest } from "../../config/Fatch.config";
import { Cookie , getBrowserVersion, _handleTheMainSiteUrlOfBackendResponse, getApiVersion } from "../../actions/util";

import Toast from '@/Toast';

class Central extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			contact : [{
				icon: '',
				text: 'Live Chat',
				href: '',
			},{
				icon: '',
				text: 'Line',
				href: '',
			},{
				icon: '',
				text: 'Facebook',
				href: '',
			},{
				icon: '',
				text: 'Youtube',
				href: '',
			}],
			error_name : false ,
			error_pwd  : false,
			error_email:false,
			error_phone:false,

			EMAIL : '',
			USERNAME : '',
			PHONE : '',
			PWD : '',
			currentUsername: '',
			currentPwd: '',
			currentEmail: '',
			currentPhone: '',
			metaRegister: false
		}
		this.Register = this.Register.bind(this);
		this.emailBox = React.createRef();
		this.phoneBox = React.createRef();
		this.usernameBox = React.createRef();
		this.passwordBox = React.createRef();
		this.phonePreFix = '+84';
	}

	/**
	 * 改变参数值
	 * @param { String } k 变量
	 * @param { String | Number | any } v 参数 
	 */
	setStates(k, v) {
		this.setState({
		  [k]: v
		});
	};


	/**
	 * onChange input 
	 * @param {*} e 
	 * @param {*} type 
	 * @returns 
	 */
	UserInput(e , type){
		let val = e.target.value || '';
		this.setStates(type,val);
		this.regInput(e , type);
		// globalGtag(`Search_withdrawalrecord_Carddetail`);
		
	}

	/**
	 * 注册
	 */
	Register(){
		console.log(123123213);
		
		let { PHONE  , EMAIL , PWD ,USERNAME} = this.state;
	
		if(PHONE === '' && EMAIL === '' && PWD === '' && USERNAME === '') {
			this.setState({
				error_phone : true,
				error_email : true,
				error_name  : true,
				error_pwd   : true,
			})
			return;
		}
		if(!this.state.error_phone && !this.state.error_email && !this.state.error_name && !this.state.error_pwd){
			try {
				let params = {
					queleaReferrerId : Cookie.GetCookieKeyValue('Referer') || '',
					referer: Cookie.GetCookieKeyValue('Referer') || '',
					hostname : global.location.origin,
					email: EMAIL,
					// hidBlackbox : (global.ioGetBlackbox && global.ioGetBlackbox().blackbox) || '',
					// hidE2:  (global.E2GetBlackbox && global.E2GetBlackbox().blackbox) || '',
					blackBoxValue:  (global.E2GetBlackbox && global.E2GetBlackbox().blackbox) || '',
					deviceSignatureBlackBox: (global.ioGetBlackbox && global.ioGetBlackbox().blackbox) || '',
					language: 'vi-vn',
					mediaCode:Cookie.GetCookieKeyValue('Media') || null,
					password : PWD,
					mobile : this.phonePreFix.substring(1,3) + "-" + PHONE,
					affiliateCode : Cookie.GetCookieKeyValue('CO_affiliate') || '' ,
					// referralCode : Cookie.GetCookieKeyValue('CO_affiliate') || '',
					regWebsite : getBrowserVersion(),
					username : USERNAME , 
					websiteId : getBrowserVersion(),
					currency: 'VND',
					brandCode: 'FUN88',
				}
				
				// piwik 追踪
				global.globalGtag && global.globalGtag('Style1_QRP','Registration form' , 'Submit_registration' ,'event');
				Toast.loading()
				fetchRequest(ApiPort.Register,'POST' , params , getApiVersion() + "&IsQrp=true").then(res =>{
					if(res){
						Toast.hide();
						if(res.isSuccess){
							this.setState({
								metaRegister: true
							}, () => {
								_handleTheMainSiteUrlOfBackendResponse(res?.result?.qrpRedirectUrl)
							})
							global.globalCTag && global.globalCTag('api_return_complete','success'); 
							global.globalGtag && global.globalGtag('Style1_QRP','Registration form' , 'Submit_registration_api_return' ,'event', 'custom');
						}else{
							global.globalCTag && global.globalCTag('api_return_complete','fail'); 
							global.globalGtag && global.globalGtag('Style1_QRP','Registration form' , 'Submit_registration_api_return' ,'event', 'custom');
							this.props.openModal(res?.result?.message || res?.errors[0]?.message);
						}
					}
				}).catch(error =>{
					console.log('服务器错误...');
				})
			} catch (error) {
				console.log('12313123');
			}
		}else{
			return ;
		}
		
	}

	/**
	 * input Blur
	 * @param {*} e 
	 * @param {*} type 
	 */
	inputOnBlur(e,type){
		this.regInput(e , type);
	}

	/**
	 * 验证Input 方法
	 * @param {*} e 
	 * @param {*} type 
	 * @returns 
	 */
	regInput(e ,type){
		let val = e.target.value || '';
		let that = this;
		let inputMap = {
			'USERNAME' : (val)=>{
				document.addEventListener('click', this.handleUsernameClick);
				if(!RegName.test(val)){
					that.setState({
						error_name : true
					},()=>{
						if(val === ''){
							document.getElementsByClassName('name-hit-error')[0].innerHTML = 'Tên đăng nhập không được để trống';
							
						}else{
							document.getElementsByClassName('name-hit-error')[0].innerHTML = 'Tên đăng nhập vượt quá số ký tự cho phép (6-14 ký tự)';
						}
						
					});	
				} else{
					that.setState({
						error_name :  false
					});
				}
				return ;
			},
			'PWD' : (val) =>{
				document.addEventListener('click', this.handlePasswordClick);
				if(!RegPassword.test(val)){
					that.setState({
						error_pwd : true
					},()=>{
						if(val === ''){
							document.getElementsByClassName('pass-hit-error')[0].innerHTML = 'Mật khẩu không được để trống';
						}else{
							document.getElementsByClassName('pass-hit-error')[0].innerHTML = "Mật khẩu phải bao gồm chữ và số, chỉ chấp nhận 'A-Z', 'a-z', '0-9'";
						}
					})
					
				}else{
					that.setState({
						error_pwd :  false
					})
				}
				return ;
			},
			'EMAIL' : (val) =>{
				document.addEventListener('click', this.handleEmailClick);
				if(!RegEmail.test(val)){
					that.setState({
						error_email : true
					},()=>{
						if(val === ''){
							document.getElementsByClassName('email-hit-error')[0].innerHTML = 'Email không được để trống';
						}else{
							document.getElementsByClassName('email-hit-error')[0].innerHTML = 'Định dạng Email không đúng. Ví dụ: abc@def.com';
						}
					})
				}else{
					that.setState({
						error_email :  false
					})
				}
				return;
				
			},
			'PHONE' : (val) =>{
				document.addEventListener('click', this.handlePhoneClick);
				if(!RegPhone.test(val)){
					that.setState({
						error_phone : true
					},()=>{
						if(val === ''){
							document.getElementsByClassName('phone-hit-error')[0].innerHTML = 'Số điện thoại không được để trống';
						}else{
							document.getElementsByClassName('phone-hit-error')[0].innerHTML = 'Số điện thoại phải có 9-10 số, vui lòng bỏ số “0” khi nhập thông tin.';
						}
					})
				}else{
					that.setState({
						error_phone :  false
					})
				}
				return
			}
		}
		inputMap[type](val);
		return ;
	}

	handleEmailClick = (event) => {
		if (this.emailBox && this.emailBox.current && !this.emailBox.current.contains(event.target) && !this.state.error_email && (this.state.currentEmail != this.state.EMAIL)) {
			this.setState({
				currentEmail :  this.state.EMAIL,
			});
			global.globalGtag && global.globalGtag('Style1_QRP','Registration form' , 'Email_input' ,'input');
			return document.removeEventListener('click', this.handleEmailClick)
		}
	}

	handlePhoneClick = (event) => {
		if (this.phoneBox && this.phoneBox.current && !this.phoneBox.current.contains(event.target) && !this.state.error_phone && (this.state.currentPhone != this.state.PHONE)) {
			this.setState({
				currentPhone :  this.state.PHONE,
			});
			global.globalGtag && global.globalGtag('Style1_QRP','Registration form' , 'Phone_input' ,'input');
			return document.removeEventListener('click', this.handlePhoneClick)
		}
	}

	handleUsernameClick = (event) => {
		if (this.usernameBox && this.usernameBox.current && !this.usernameBox.current.contains(event.target) && !this.state.error_name && (this.state.currentUsername != this.state.USERNAME)) {
			this.setState({
				currentUsername :  this.state.USERNAME,
			});
			global.globalGtag && global.globalGtag('Style1_QRP','Registration form' , 'Username_input' ,'input');
			return document.removeEventListener('click', this.handleUsernameClick)
		}
	}

	handlePasswordClick = (event) => {
		if (this.passwordBox && this.passwordBox.current && !this.passwordBox.current.contains(event.target) && !this.state.error_pwd && (this.state.currentPwd != this.state.PWD)) {
			this.setState({
				currentPwd :  this.state.PWD,
			});
			global.globalGtag && global.globalGtag('Style1_QRP','Registration form' , 'Password_input' ,'input');
			return document.removeEventListener('click', this.handlePasswordClick)
		}
	}

	render(){
		let {error_name ,error_pwd , error_email , error_phone , PWD ,USERNAME , EMAIL , PHONE, metaRegister } = this.state;
		let { Copies } = this.props;
		let aff = global.document && Cookie.GetCookieKeyValue('CO_affiliate') || '';
		return (

			<>
				{metaRegister  && global.fbqTag && fbqTag('CompleteRegistration')}    
				<Banner bannerList = { this.props.bannerList }></Banner>
				<div className="central-web web">
					<div className='text-top'>
						<h2>FUN88 x IKER CASILLAS</h2>
						<p>Thưởng <storage>6 TRIỆU</storage>Tại Thể Thao</p>
					</div>
					<div className="central-box web">
						<div className={'heading'}>ĐĂNG KÝ TÀI KHOẢN</div>
						{!Copies ? <p className={'tips'}>Game Thuần Việt Cho Người Việt <br />
						Tài Xỉu – Xóc Đĩa – Bầu Cua Tôm Cá</p> : <p className={'tips'}>Uy Tín Khẳng Định Giá Trị​<br />
						Thương Hiệu Hàng Đầu Châu Á​</p>}
						<div className={'form-modal'}>
							<div className="namePass">
								{/* 用户名 */}
								<div style={{width: '49%'}} ref={this.usernameBox} className="usernameBox">
									<Input style={{width: '100%'}} onBlur={(e)=>{this.inputOnBlur(e ,'USERNAME')}} type={'name'} onChange={(e)=>{this.UserInput(e ,'USERNAME')}} maxLength={14} placeholder="Tên đăng nhập" value={USERNAME}></Input>
								</div>
								{/* 密码 */}
								<div style={{width: '49%'}} ref={this.passwordBox} className="passwordBox">
									<Input style={{width: '100%'}} type={'password'} onBlur={(e)=>{this.inputOnBlur(e ,'PWD')}} onChange={(e)=>{this.UserInput(e ,'PWD')}} maxLength={20} name="password" placeholder="Mật khẩu" value={PWD}></Input>
								</div>
							</div>
							<div className="error-hit">
								{/* 用户名错误显示 */}
								{error_name ? <p className="name-hit-error">Tên đăng nhập không được để trống</p> : <p></p>}
								{error_pwd ? <p className="pass-hit-error">Mật khẩu không được để trống</p> :<p></p>}
							</div>
							{/*  */}
							{/* 电子邮件 */}
							<div className="email-input" ref={this.emailBox}>
								<Input name="email" onBlur={(e)=>{this.inputOnBlur(e ,'EMAIL')}} maxLength={100} placeholder="Email" onChange={(e)=>{this.UserInput(e ,'EMAIL')}} value={EMAIL}></Input>
							</div>
							<div className="error-hit">
								{error_email ? <p className="email-hit-error">Email không được để trống</p> :<p></p>}
							</div>

							{ /* 电话号码 */ }
							<div className="phone-number" ref={this.phoneBox}>
								<Input className="phone" name="phone" disabled type="tel" value={this.phonePreFix}></Input>
								<Input className="phoneNumber" onBlur={(e)=>{this.inputOnBlur(e ,'PHONE')}} maxLength={10} name="phoneNumber" id="inputPhone" placeholder="Số điện thoại vui lòng không nhập số 0 ở đầu" onChange={(e)=>{this.UserInput(e ,'PHONE')}} value={PHONE}></Input>
							</div>
							<div className="error-hit">
								{error_phone ? <p className="phone-hit-error">Số điện thoại không được để trống</p> :<p></p>}
							</div>


							<div className="Hyperlinks" style={{fontSize:'12px',textAlign:'center'}}>Bằng cách nhấp vào nút ĐĂNG KÝ, bạn xác minh rằng bạn từ 21 tuổi trở lên và đồng ý với <a target="_blank" href={`${this.props.mainSiteUrl}help/gamble-responsibly/${aff ? `?aff=${aff}` : ''}`} > Điều khoản và Điều kiện </a> và <a target="_blank" href={`${this.props.mainSiteUrl}help/privacy-policy/${aff ? `?aff=${aff}` : ''}`}> Chính sách bảo mật</a> của chúng tôi.</div>
						</div>
						<Button className="submit" onClick={()=>{this.Register()}}>Tham gia ngay</Button>
					</div>
				</div>
				{/* mobile and ipad */}
				<div className="mobile">
					<div className="mobile-central">
						<div className='text-top'>
							<h2>FUN88 x IKER CASILLAS</h2>
							{/*<p>โบนัสสูง 150% ฟรีเสื้อบอลโลก</p>*/}
						</div>
					</div>

					<div className="central-box" id="mobile-heading">
						<div className={'heading'}>ĐĂNG KÝ TÀI KHOẢN</div>
						{!Copies ? <p className={'tips'}>Game Thuần Việt Cho Người Việt <br />
						Tài Xỉu – Xóc Đĩa – Bầu Cua Tôm Cá</p> : <p className={'tips'}>Uy Tín Khẳng Định Giá Trị​<br />
						Thương Hiệu Hàng Đầu Châu Á​</p>}
					</div>

					<div className={'form-modal'}>
						<div className="namePass">
							{/* 用户名 */}
							<Input onBlur={(e)=>{this.inputOnBlur(e ,'USERNAME')}} onChange={(e)=>{this.UserInput(e ,'USERNAME')}} maxLength={14} placeholder="Tên đăng nhập" value={USERNAME} ></Input>
							{/* 密码 */}
							<Input maxLength={20}  onBlur={(e)=>{this.inputOnBlur(e ,'PWD')}} onChange={(e)=>{this.UserInput(e ,'PWD')}} name="password" type={'password'} placeholder="Mật khẩu" value={PWD}></Input>
						</div>

						<div className="error-hit">
							{/* 用户名错误显示 */}
							{error_name && !USERNAME ? <p className="name-hit-error">Tên đăng nhập không được để trống</p> : error_name && USERNAME ? <p className="name-hit-error">Tên đăng nhập vượt quá số ký tự cho phép (6-14 ký tự)</p> :  <p className="name-hit-error"></p>}
							{error_pwd && !PWD ? <p className="pass-hit-error">Mật khẩu không được để trống</p> : error_pwd && PWD ? <p className="pass-hit-error">Mật khẩu phải bao gồm chữ và số, chỉ chấp nhận 'A-Z', 'a-z', '0-9'</p> : <p className="pass-hit-error"></p>}
						</div>

						
						{/* 电子邮件 */}
						<div className="email-input">
							<Input onBlur={(e)=>{this.inputOnBlur(e ,'EMAIL')}}  onChange={(e)=>{this.UserInput(e ,'EMAIL')}} value={EMAIL} name="email" maxLength={100} placeholder="Email"></Input>
						</div>
						<div className="error-hit">
						{error_email && !EMAIL? <p className="email-hit-error">Email không được để trống</p> : error_email && EMAIL ?<p className="email-hit-error">Định dạng Email không đúng. Ví dụ: abc@def.com</p> : null}
						</div>
						{ /* 电话号码 */ }
						<div className="phone-number">
							<Input className="phone" name="phone" disabled type="tel" value={this.phonePreFix}></Input>
							<Input className="phoneNumber" maxLength={10} name="phoneNumber" id="inputPhone" placeholder="Số điện thoại vui lòng không nhập số 0 ở đầu" onBlur={(e)=>{this.inputOnBlur(e ,'PHONE')}} onChange={(e)=>{this.UserInput(e ,'PHONE')}} value={PHONE}></Input>
						</div>
						<div className="error-hit">
							{error_phone && !PHONE ? <p className="phone-hit-error">Số điện thoại không được để trống</p> :  error_phone && PHONE ? <p className="phone-hit-error">Số điện thoại phải có 9-10 số, vui lòng bỏ số “0” khi nhập thông tin.</p>: null}
						</div>

						<div className="Hyperlinks" style={{fontSize:'12px',textAlign:'center'}}>Bằng cách nhấp vào nút ĐĂNG KÝ, bạn xác minh rằng bạn từ 21 tuổi trở lên và đồng ý với <a target="_blank" href={ this.props.mainSiteUrl + `/help/Policy-TermsAndCondition.htm${aff ? `?aff=${aff}` : ''}`} > Điều khoản và Điều kiện </a> và <a target="_blank" href={this.props.mainSiteUrl + `/help/policy-privacy.htm${aff ? `?aff=${aff}` : ''}`}> Chính sách bảo mật</a> của chúng tôi.</div>

					</div>
					<Button className="submit" onClick={()=>{this.Register()}}>Tham gia ngay</Button>
				</div>
			</>
		)
	}
}


export default Central;
